import React from 'react'
import './Contact.scss'

import Map from './GoogleMapComponent/GoogleMapComponent'
const contact = () => {
  return (
    <footer className="contact" id="contact">
      <div className="contact__data">
        <div className="contact__data__text">
          <h2 className="contact__data__text__title">Kontakt</h2>
          <h3 className="contact__data__text__name">Wojciech Jagsz</h3>
          <h3 className="contact__data__text__others">ul.Kopańska 12, 43-150 Bieruń</h3>
          <h3 className="contact__data__text__others">tel: 32 216 40 66</h3>
          <h3 className="contact__data__text__others">e-mail: komin.jagsz@wp.pl</h3>
        </div>
      </div>
      <div className="contact__googleMaps">
        <Map
          googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_GOOGLE_API_KEY}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `100%` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
    </footer>
  )
}

export default contact
